import * as React from "react";

import {UserDto} from "../../../services/Client";

import SelectField, {OptionValue} from "../../../components/SelectField";

export interface IDeputySelectionProps {
    /** Displayed when there's no deputy selected. */
    placeholder?: string;

    /** Data source array. All available deputies. */
    users: UserDto[];

    /** Initially selected deputy. */
    value?: UserDto;

    /** Callback when a deputy is selected or the select field is cleared. */
    onChange: (user: UserDto | undefined) => any;
}

/**
 * DeputySelection is a select field component enables the selection of
 * deputies for UserDtos. There may be only one deputy per user.
 */
export const DeputySelection = (props: IDeputySelectionProps) => (
    <SelectField
        placeholder={props.placeholder}
        searchable={true}
        clearable={true}
        dataSource={props.users}
        value={props.value}
        rendererKey={(user: UserDto) => `${user.cn} - ${user.name || ''} ${user.department ? `- (${user.department})`:''}`}
        rendererOption={(user: any) => {
            return <>{`${user.option.cn} - ${user.option.name || ''} ${user.option.department ? `(${user.option.department})`:''}`}</>;
        }}
        onChange={(selectedValue?: OptionValue, selectedIndex?: number) => {
            props.onChange(selectedValue ? selectedValue as UserDto : undefined);
        }}
    />
);

export default DeputySelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/DeputySelection.tsx